const DEFAULT_VALUE_VARIATION = 'primary';
const ICON_VIEWBOX = '0 0 24 24';

export { DEFAULT_VALUE_VARIATION, ICON_VIEWBOX };
